import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { Outlet } from 'react-router';
import 'react-toastify/dist/ReactToastify.css';

import Providers from './Providers';

const App = () => (
  <Providers>
    <Outlet />
  </Providers>
);

export default App;
